(function() {
  angular
    .module('cfn')
    .factory('fieldGroupCoreDataResolver', fieldGroupCoreDataResolver);

  fieldGroupCoreDataResolver.$inject = ['FieldGroup'];
  // resolve function bef
  function fieldGroupCoreDataResolver(FieldGroup) {
    return function() {
      return coreCommonResolveFunction(FieldGroup, true);
    };
  }
})();
